import {
    centsToFormattedDollars,
    formattedDollarsToCents,
    roundCentsToWholeDollarCents,
} from '@fruitful/fruitils';
import { AccountCategory } from '@fruitful/types';

/** Same max width as take-home pay `MoneyMapperIncomeDetailsModal` inner content. */
export const GROVE_WIDE_MODAL_MAX_WIDTH_PX = 600;

/** DollarInput display string from whole cents (matches money-map manual row formatting). */
export const centsToDollarInputDisplayString = (cents: number): string =>
    centsToFormattedDollars(roundCentsToWholeDollarCents(cents), false).replace(
        '$',
        '$ ',
    );

export const parseDollarInputStringToCents = (value: string): number | null => {
    const raw = formattedDollarsToCents(value);
    if (Number.isNaN(raw)) {
        return null;
    }
    return roundCentsToWholeDollarCents(raw);
};

export const getAccountCategoryPickerOptions = (): Array<{
    label: string;
    value: AccountCategory;
}> =>
    Object.values(AccountCategory)
        .filter(
            (v) => v !== AccountCategory.OTHER && v !== AccountCategory.UNKNOWN,
        )
        .map((value) => ({
            label: value
                .replace(/_/g, ' ')
                .toLowerCase()
                .replace(/\b\w/g, (c) => c.toUpperCase()),
            value,
        }));
